module.exports = __webpack_public_path__ + "img/lt_choice_language.4c40eceb.png";